export default __webpack_public_path__ + "static/media/sipky.569caf2f.svg";